const Wishlist = {
  key: 'shopify_wishlist',

  get() {
    try {
      const items = JSON.parse(localStorage.getItem(this.key));
      return Array.isArray(items) ? items : [];
    } catch (e) {
      return [];
    }
  },

  save(items) {
    try { localStorage.setItem(this.key, JSON.stringify(items)); } catch (e) {}
    this.refresh();
  },

  has(handle) {
    return this.get().includes(handle);
  },

  toggle(handle) {
    if (!handle) return;
    let items = this.get();
    items = items.includes(handle) ? items.filter(i => i !== handle) : [...items, handle];
    this.save(items);
  },

  remove(handle) {
    this.save(this.get().filter(i => i !== handle));
  },

  updateCount() {
    const count = this.get().length;
    document.querySelectorAll('.wishlist-count').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  },

  updateIcons(root = document) {
    const items = this.get();
    root.querySelectorAll('.wishlist-btn').forEach(btn => {
      const isActive = items.includes(btn.dataset.handle);
      btn.classList.toggle('active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      btn.setAttribute('aria-label', isActive ? 'Remove from Wishlist' : 'Add to Wishlist');
      const path = btn.querySelector('svg path');
      if (path) {
        const fill = isActive ? '#d23b3b' : 'none';
        if (path.getAttribute('fill') !== fill) {
          path.setAttribute('fill', fill);
          path.setAttribute('stroke', isActive ? '#d23b3b' : 'currentColor');
        }
      }
      const label = btn.querySelector('[data-wishlist-label]');
      const text = isActive ? 'Saved to wishlist' : 'Add to wishlist';
      if (label && label.textContent !== text) label.textContent = text;
    });
  },

  refresh() {
    this.updateCount();
    this.updateIcons();
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items: this.get() } }));
  },

  init() {
    if (this.ready) return;
    this.ready = true;

    document.addEventListener('click', e => {
      const btn = e.target.closest('.wishlist-btn');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      this.toggle(btn.dataset.handle);
    }, true);

    // Cards added later (filters, sorting, recommendations, quick search) get the right heart state.
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; this.updateIcons(); });
    }).observe(document.body, { childList: true, subtree: true });

    // Keep other open tabs in sync.
    window.addEventListener('storage', e => { if (e.key === this.key) this.refresh(); });
    window.addEventListener('pageshow', () => this.refresh());

    this.updateCount();
    this.updateIcons();
  }
};

window.Wishlist = Wishlist;
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => Wishlist.init());
} else {
  Wishlist.init();
}
